<template>
  <div class="relative overflow-hidden">
    <CardSlider class="my-20" :heading="heading" :breakpoints="breakpoints" :display-overflow="true">
      <div v-for="(slide, index) in rotationSlides" :key="index" class="relative">
        <div class="slide relative">
          <FixedAspect :ratio="2 / 3">
            <CldnImg
              v-if="slide.preview[0]"
              :src="slide.preview[0].url"
              :alt="slide.alt"
              crop="fill"
              sizes="70vw sm:70vw md:70vw lg:70vw xl:70vw 2xl:70vw"
              class="block select-none transition-transform"
            />
          </FixedAspect>
          <div class="absolute inset-0 flex items-center justify-center">
            <PlayBtn class="lg:w-20 lg:h-20 w-16 h-16" @click="modalOpenedId = index" />
          </div>
        </div>
        <div
          v-if="slide.textOverlay"
          class="md:absolute md:px-12 fluid-lg leading-tight font-medium md:py-8 bottom-0 left-0 py-4"
          v-html="slide.textOverlay"
        ></div>
        <Modal :showing="modalOpenedId === index" fullscreen :min-width="true" @close="modalOpenedId = null">
          <CraftAsset :asset="slide.video[0]" class="w-full" />
        </Modal>
      </div>
    </CardSlider>
  </div>
</template>

<script>
import CraftAsset from '~/components/common/CraftAsset';
import CldnImg from '~/components/CldnImg';
import Modal from '~/components/common/Modal';
import PlayBtn from '~/components/common/PlayBtn';
import FixedAspect from '~/components/common/FixedAspect';
import CardSlider from '~/components/common/CardSlider';

export default defineNuxtComponent({
  components: { CardSlider, FixedAspect, CldnImg, Modal, PlayBtn, CraftAsset },
  props: {
    heading: {
      type: String,
      default: null,
    },
    rotationSlides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalOpenedId: null,
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      ],
    };
  },
});
</script>
